// Constants for NewSubTaskInline component

export const TASK_STATUSES = [
    { id: "NOT-STARTED", name: "Not Started", color: "#6b7280" },
    { id: "IN-PROGRESS", name: "In Progress", color: "#3b82f6" },
    { id: "IN-REVIEW", name: "In Review", color: "#f59e0b" },
    { id: "COMPLETED", name: "Completed", color: "#10b981" },
    { id: "CANCELLED", name: "Cancelled", color: "#B0BEC5" },
] as const;

export const COLOR_OPTIONS = [
    { value: "purple", label: "Purple", bgColor: "#e9d5ff", textColor: "#7c3aed" },
    { value: "indigo", label: "Indigo", bgColor: "#c7d2fe", textColor: "#4338ca" },
    { value: "violet", label: "Violet", bgColor: "#ddd6fe", textColor: "#7c2d12" },
    { value: "red", label: "Red", bgColor: "#fecaca", textColor: "#dc2626" },
    { value: "green", label: "Green", bgColor: "#bbf7d0", textColor: "#16a34a" },
    { value: "blue", label: "Blue", bgColor: "#bfdbfe", textColor: "#2563eb" },
    { value: "orange", label: "Orange", bgColor: "#fed7aa", textColor: "#ea580c" },
    { value: "yellow", label: "Yellow", bgColor: "#fef3c7", textColor: "#d97706" },
] as const;

export const VALIDATION_RULES = {
    eventName: {
        required: "Task summary is required",
    },
    projectId: {
        required: "Project selection is required",
    },
    taskStatus: {
        required: "Task status is required",
    },
    startDateTime: {
        required: "Start date and time is required",
    },
    endDateTime: {
        required: "End date and time is required",
    },
    assignee: {
        required: "Assignee selection is required",
    },
} as const;
